// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.0233b77bb.chunk.js";
	if (chunkId === 12) return "static/js/profiler.0233b77bb.chunk.js";
	if (chunkId === 434) return "static/js/434.0233b77bb.chunk.js";
	if (chunkId === 625) return "static/js/625.0233b77bb.chunk.js";
	if (chunkId === 160) return "static/js/160.0233b77bb.chunk.js";
	if (chunkId === 103) return "static/js/103.0233b77bb.chunk.js";
	if (chunkId === 177) return "static/js/177.0233b77bb.chunk.js";
	// return url for filenames based on template
	return undefined;
};